import React from 'react';
import './LatestBlogs.scss';

import { motion } from 'framer-motion';

import { homePage } from '../../../editable-stuff/config';

export default function LatestBlogs() {
  return (
    <section id='blog-latest' className='p-150'>
      <div className='wave-top'>
        <svg
          fill='#f6f6f6'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 300'
          preserveAspectRatio='none'
        >
          <path d='M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z'></path>
          <path d='M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z'></path>
          <path d='M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z'></path>
        </svg>
      </div>
      <div className='container'>
        <div className='headers text-center mb-8'>
          <motion.h4
            initial={{ y: '100px', opacity: 0 }}
            whileInView={{ y: '0', opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {homePage?.latestBlogs?.title}
          </motion.h4>
          <motion.h2
            className='gradient'
            initial={{ y: '100px', opacity: 0 }}
            whileInView={{ y: '0', opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {homePage?.latestBlogs?.gradient_title}
          </motion.h2>
        </div>
        <div className='row'>
          <div className='col-lg-6'>
            <BlogItem
              type='vertical'
              category='Agency News'
              title='Website Launch - Gibraltar Nature Reserve'
              descp={`We're very proud to announce the Official web platform for
            the Upper Rock Nature Reserve - Gibraltar's primary
            destination.`}
              author='Tyler Hounsome'
              image={require('../../../assets/img/Blogs/blog-post-1.jpg')}
              categoryLink='#'
              blogLink='#'
            />
          </div>
          <div className='col-lg-6'>
            <BlogItem
              type='horizontal'
              category='Website Design'
              title='The Purpose of Mental Models in Web Design'
              descp={`When we interact with things - we connect the dots on how it
              works and what we anticipate happening next, these processes
              are known as mental models.`}
              author='CBD Team'
              image={require('../../../assets/img/Blogs/blog-post-2.jpg')}
              categoryLink='#'
              blogLink='#'
            />
            <BlogItem
              type='horizontal'
              category='Website Design'
              title='Sustainable Website Design Tips'
              descp={`Sustainability is something that affects us all, and has
              evolved into a crucial factor across all industries - it was
              only a matter of time before Web Design would become one of
              them.`}
              author='Chris Saunders'
              image={require('../../../assets/img/Blogs/blog-post-3.jpg')}
              categoryLink='#'
              blogLink='#'
            />
          </div>
        </div>
      </div>
    </section>
  );
}

interface BlogsProps {
  type: string;
  image: string;
  category: string;
  title: string;
  descp: string;
  author: string;
  categoryLink: string;
  blogLink: string;
}

const BlogItem = ({
  type,
  image,
  category,
  title,
  descp,
  author,
  categoryLink,
  blogLink,
}: BlogsProps) => {
  return (
    <div className={`single-holder ${type ?? 'vertical'}`}>
      <div className='single'>
        <a href={blogLink ?? '#'} className='image'>
          <div
            className='simpleParallax simple-parallax-initialized'
            style={{ overflow: 'hidden' }}
          >
            <motion.img
              loading='lazy'
              className='img-parallax'
              src={image}
              alt='blog post thumbnail'
              initial={{
                transform: 'translate3d(0px, 0px, 0px) scale(1)',
                opacity: 0,
              }}
              whileInView={{
                transform: 'translate3d(0px, 11px, 0px) scale(1.2)',
                opacity: 1,
              }}
              transition={{ duration: 1 }}
              style={{
                transform: 'translate3d(0px, -2px, 0px) scale(1.2)',
                willChange: 'transform',
                transition: 'transform 0.6s cubic-bezier(0, 0, 0, 1) 0s',
              }}
            />
          </div>
        </a>
        <div className='content'>
          <div className='cats'>
            <a href={categoryLink ?? '#'}>{category}</a>
          </div>
          <h3>{title}</h3>
        </div>
      </div>
      <a className='excerpt' href={blogLink ?? '#'}>
        <div>
          <p>{descp}</p>{' '}
        </div>
        <h6>
          <strong>
            <em>by {author}</em>
          </strong>
        </h6>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
          <path d='M427.8 266.8l-160 176c-3.1 3.5-7.5 5.2-11.8 5.2-3.844 0-7.703-1.375-10.77-4.156-6.531-5.938-7.016-16.06-1.078-22.59L379.8 272H16C7.156 272 .9 264.845.9 256.9S7.156 240 16 240h363.8L244.1 90.7c-5.938-6.531-5.453-16.66 1.078-22.59 6.547-5.906 16.66-5.469 22.61 1.094l160 176c5.612 6.096 5.612 15.496.012 21.596z'></path>
        </svg>
      </a>
    </div>
  );
};
